import { FeePricingType, FeeQuantitySource } from '../api/feeCategoriesApi';

export interface FeeQuantityContext {
  pricingType?: FeePricingType | string;
  autoCloseMonthly?: boolean;
  isMonthlyFixed?: boolean;
  quantitySource?: FeeQuantitySource | string | null;
  quantityUnit?: string | null;
  name?: string;
}

/** Quantity is entered when staff creates each invoice (e.g. card issuance). */
export function usesPerInvoiceQuantity(fee: FeeQuantityContext): boolean {
  return (
    (fee.pricingType === FeePricingType.SINGLE_TIER || fee.pricingType === 'SINGLE_TIER') &&
    !fee.autoCloseMonthly
  );
}

export function getFeeCategoryDisplayUnit(fee: FeeQuantityContext): string {
  if (fee.quantityUnit?.trim()) {
    return fee.quantityUnit.trim();
  }
  const name = (fee.name || '').toLowerCase();
  if (name.includes('xe')) return 'xe';
  if (
    fee.quantitySource === FeeQuantitySource.APARTMENT_AREA ||
    fee.quantitySource === 'APARTMENT_AREA'
  ) {
    return 'm²';
  }
  if (fee.isMonthlyFixed) return 'căn';
  return 'đơn vị';
}

export function formatPriceWithUnit(price: string, fee: FeeQuantityContext): string {
  const unit = getFeeCategoryDisplayUnit(fee);
  return `${price} / ${unit}`;
}

export function isApartmentStoredQuantity(fee: FeeQuantityContext): boolean {
  if (usesPerInvoiceQuantity(fee)) return false;
  const source = fee.quantitySource || FeeQuantitySource.MANUAL;
  return (
    source === FeeQuantitySource.MANUAL ||
    source === 'MANUAL' ||
    source === FeeQuantitySource.APARTMENT_AREA ||
    source === 'APARTMENT_AREA' ||
    source === FeeQuantitySource.FIXED_ONE ||
    source === 'FIXED_ONE'
  );
}

export function isApartmentQuantityEditable(fee: FeeQuantityContext): boolean {
  if (usesPerInvoiceQuantity(fee)) return false;
  if (
    fee.quantitySource === FeeQuantitySource.APARTMENT_AREA ||
    fee.quantitySource === 'APARTMENT_AREA' ||
    fee.quantitySource === FeeQuantitySource.FIXED_ONE ||
    fee.quantitySource === 'FIXED_ONE'
  ) {
    return false;
  }
  return Boolean(fee.autoCloseMonthly);
}
